import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";

const TermsAndConditionsModal = ({ open, onClose, onAgree }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Terms and Conditions - i-Chest Company</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body1" gutterBottom>
            This agreement is for i-Chest Company terms and conditions.
        </Typography>
        <Typography variant="body2" gutterBottom>
            1. Acceptance of Terms: By accessing and using our services, you agree to be bound by these terms and conditions.
        </Typography>
        <Typography variant="body2" gutterBottom>
            2. Use of Services: You agree to use the services only for lawful purposes and in a manner consistent with all applicable laws.
        </Typography>
        <Typography variant="body2" gutterBottom>
            3. Privacy: We respect your privacy and are committed to protecting your personal information as described in our privacy policy.
        </Typography>
        <Typography variant="body2" gutterBottom>
            4. Intellectual Property: All content provided by i-Chest Company is protected by copyright and other intellectual property laws.
        </Typography>
        <Typography variant="body2" gutterBottom>
            5. Limitation of Liability: i-Chest Company shall not be liable for any damages arising from the use or inability to use our services.
        </Typography>
        <Typography variant="body2" gutterBottom>
            6. Changes to Terms: We reserve the right to modify these terms at any time. Continued use of our services constitutes acceptance of the updated terms.
        </Typography>
        <Typography variant="body2" gutterBottom>
            7. Termination: We may suspend or terminate your access to services if you violate these terms.
        </Typography>
        <Typography variant="body2" gutterBottom>
            8. Governing Law: These terms are governed by and construed in accordance with the laws of the jurisdiction where i-Chest Company operates.
        </Typography>
        <Typography variant="body2" gutterBottom>
            9. Contact Information: For any questions or concerns about these terms, please contact our support team.
        </Typography>
        <Typography variant="body2" gutterBottom>
            Please read the full terms carefully before agreeing.
        </Typography>
        </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onAgree} color="primary" variant="contained">Agree</Button>
      </DialogActions>
    </Dialog>
  );
};

export default TermsAndConditionsModal;
